import { Transform } from 'class-transformer';

export const ToPlainObject = () => Transform(({ key, obj }) => JSON.parse(JSON.stringify(obj[key])));
